import styled from 'styled-components';

export const FilterDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  height: 100%;
`;

export const DropdownButton = styled.button<{ isOpen: boolean }>`
  background: none;
  border: 1px solid #57069e;
  color: #57069e;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  height: 41px;
  min-width: 140px;

  &:hover {
    background: rgba(87, 6, 158, 0.04);
  }

  &:disabled {
    background: #f5f5f5;
    border-color: #d8d8d8;
    color: #999;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background: #f5f5f5;
  }

  &:focus {
    outline: none;
    border-color: #57069e;
    box-shadow: 0 0 0 2px rgba(87, 6, 158, 0.18);
  }

  svg {
    font-size: 16px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);

  right: 0;
  left: auto;

  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.06);
  z-index: 1000;

  min-width: 280px;
  max-width: min(420px, 90vw);
  max-height: 320px;
  overflow-y: auto;

  transform-origin: top right;
  animation: dropdownIn 120ms ease-out;

  @keyframes dropdownIn {
    from {
      opacity: 0;
      transform: scale(0.98) translateY(-2px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
`;

export const DropdownSearch = styled.div`
  position: sticky;
  top: 0;
  background: #fff;
  padding: 8px;
  border-bottom: 1px solid #f2f2f2;
  z-index: 1;

  input {
    width: 100%;
    height: 34px;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 14px;
    transition: border-color 0.2s ease;

    &::placeholder {
      color: #999;
    }

    &:focus {
      outline: none;
      border-color: #57069e;
      box-shadow: 0 0 0 2px rgba(87, 6, 158, 0.12);
    }
  }
`;

export const EmptyState = styled.div`
  padding: 14px 16px;
  font-size: 14px;
  color: #666;
`;

export const DropdownItem = styled.div<{ disabled?: boolean }>`
  padding: 10px 14px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border-bottom: 1px solid #f7f7f7;
  transition: background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
  color: ${(props) => (props.disabled ? '#999' : '#333')};
  opacity: 1;
  filter: none;
  mix-blend-mode: normal;

  &[data-dim='true'] {
    opacity: 0.58;
  }

  [data-has-query='false'] & {
    opacity: 1 !important;
    color: #333 !important;
    filter: none !important;
    mix-blend-mode: normal !important;
  }

  &:hover,
  &[data-active='true'],
  &:focus {
    background-color: ${(props) =>
      props.disabled ? 'transparent' : '#f7f3fb'};
    opacity: 1;
  }

  &:last-child {
    border-bottom: none;
  }

  .campo-nome {
    display: block;
    font-weight: 600;
    margin-bottom: 2px;
    line-height: 1.2;
    color: #222;

    mark {
      background: #fde68a;
      border-radius: 3px;
      padding: 0 2px;
    }
  }

  .campo-sinonimo {
    display: block;
    font-size: 12px;
    color: #555;

    mark {
      background: #fef3c7;
      border-radius: 3px;
      padding: 0 2px;
    }
  }
`;
